<!-- Navigation -->
<nav class="navbar navbar-expand-lg modern-nav" *ngIf="showNavigation()">
    <div class="container-fluid">
        <a class="navbar-brand-wrapper" routerLink="/landing">
            <i class="bi bi-boxes icon-brand"></i>
            SchucoGate
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav me-auto ms-3">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/landing" routerLinkActive="active">
                        <i class="bi bi-house me-1"></i> Home
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/articles" routerLinkActive="active">
                        <i class="bi bi-journal-text me-1"></i> Article Staging
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/articles-management" routerLinkActive="active">
                        <i class="bi bi-folder me-1"></i> Articles Management
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/systems" routerLinkActive="active">
                        <i class="bi bi-diagram-3 me-1"></i> Systems
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/rules-dashboard" routerLinkActive="active">
                        <i class="bi bi-clipboard-data me-1"></i> Rules Dashboard
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/dxf-to-jpg" routerLinkActive="active">
                        <i class="bi bi-file-earmark-image me-1"></i> DXF to JPG
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/decision-tree" routerLinkActive="active">
                        <i class="bi bi-diagram-2 me-1"></i> Decision
                    </a>
                </li>
            </ul>
            <ul class="navbar-nav ms-auto">
                <li class="nav-item" *ngIf="loggedIn">
                    <button class="btn btn-modern btn-logout" (click)="logout()">
                        <i class="bi bi-box-arrow-right me-1"></i> Logout
                    </button>
                </li>
            </ul>
        </div>
    </div>
</nav>

<router-outlet></router-outlet>
<app-toasts></app-toasts>